import { useState } from 'react';
import { ColumnFiltersState, SortingState } from '@tanstack/react-table';

export function useTableState() {
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const [expandedRows, setExpandedRows] = useState<Set<string>>(new Set());
  const [loadingRows, setLoadingRows] = useState<Set<string>>(new Set());
  const [errorRows, setErrorRows] = useState<Record<string, string>>({});
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
  const [sorting, setSorting] = useState<SortingState>([]);

  return {
    pagination,
    setPagination,
    expandedRows,
    setExpandedRows,
    loadingRows,
    setLoadingRows,
    errorRows,
    setErrorRows,
    columnFilters,
    setColumnFilters,
    sorting,
    setSorting,
  };
}